import React from 'react';
import logo from 'assets/images/imageIcons/logo.png';
import './vendorOnboarding.css';

const VendorOnboardingLayout = ({ title, children, isLoading }) => (
  <div className="vendor-onboarding-page">
    <div className="vendor-onboarding-header">
      <div className="vendor-onboarding-logo">
        <img src={logo} alt="Fusion" width={99} />
        <span>Fusion</span>
      </div>
    </div>
    <div className="vendor-onboarding-panel">
      <div className="vendor-onboarding-title">
        <h4>{title || 'Vendor Onboarding Form'}</h4>
      </div>
      {isLoading && (
        <div className="vendor-onboarding-loading">Loading...</div>
      )}
      {!isLoading && children}
    </div>
  </div>
);

export default VendorOnboardingLayout;
